/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_KeepInputs */

const cs_gdpr_review_keep = /** @type {(inputs: Gdpr_Review_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechat`)
};

const en_gdpr_review_keep = /** @type {(inputs: Gdpr_Review_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep`)
};

/**
* | output |
* | --- |
* | "Keep" |
*
* @param {Gdpr_Review_KeepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_keep = /** @type {((inputs?: Gdpr_Review_KeepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_KeepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_keep(inputs)
	return cs_gdpr_review_keep(inputs)
});